import { EmployeeType } from '@prisma/client';
import { Tag, TagProps, theme } from 'antd';

export const useEmployeeTypeTag = (type: EmployeeType) => {
  const { token } = theme.useToken();

  const color =
    type === EmployeeType.INTEL
      ? token.colorPrimary
      : type === EmployeeType.CONTINGENT_WORKER
        ? token.green7
        : '#8c8c8c';

  const getProps = (props?: TagProps): TagProps => {
    switch (type) {
      case EmployeeType.INTEL:
        return { ...props, color, children: 'Intel' };
      case EmployeeType.CONTINGENT_WORKER:
        return { ...props, color, children: 'CW' };
      case EmployeeType.FACELESS_ACCOUNT:
        return { ...props, color, children: 'Faceless' };
      case EmployeeType.ANY:
        return { ...props, color, children: 'Any' };
      default:
        return { ...props, color, children: type ? type.toString() : '' };
    }
  };

  return { getProps };
};

export type EmployeeTypeRendererProps = {
  employeeType?: EmployeeType | null;
};

export const EmployeeTypeRenderer = ({ employeeType }: EmployeeTypeRendererProps) => {
  const { token } = theme.useToken();

  let color = '#8c8c8c';
  let label = employeeType ? employeeType.toString() : '';

  switch (employeeType) {
    case EmployeeType.INTEL:
      color = token.colorPrimary;
      label = 'Intel';
      break;
    case EmployeeType.CONTINGENT_WORKER:
      color = token.green7;
      label = 'CW';
      break;
    case EmployeeType.FACELESS_ACCOUNT:
      label = 'Faceless';
      break;
    case EmployeeType.ANY:
      label = 'Any';
      break;
    default:
      break;
  }

  return <Tag color={color}>{label}</Tag>;
};
